"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLeafOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27 4c-.54 0-12.9.38-18.2 5.68a9.58 9.58 0 000 13.53 11.44 11.44 0 001.07.91 17.88 17.88 0 000 6.88h2.05a15.73 15.73 0 01-.16-5.81 9.57 9.57 0 0010.61-2C27.94 17.59 28 5.51 28 5V4zm-6.08 17.79a7.59 7.59 0 01-8.77 1.4v-.21a15.55 15.55 0 014.43-7.2l-1.25-1.56a17.27 17.27 0 00-5 7.76 1.8 1.8 0 01-.2-.19 7.57 7.57 0 010-10.7c3.9-3.9 12.71-4.83 15.76-5-.06 2.96-.84 11.57-4.97 15.7z" })));
}
exports.default = SvgLeafOutline;
//# sourceMappingURL=LeafOutline.js.map